<template>
  <page-view>
    <template slot="action">
      <a-space size="small">
        <a-button @click="onExternalExpert">库外专家申请</a-button>
        <a-button @click="onAppoint">补录或指定专家</a-button>
        <a-button v-show="user.permissions['system.manage'] || deptDisabled" @click="setRuleVisible = true">设置规则
        </a-button>
        <a-button :loading="saveLoading" type="primary" @click="onSave">提交</a-button>
      </a-space>
    </template>
    <div id="Base-Props" style="position: absolute;top: 0"></div>
    <a-card>
      <a-spin :spinning="spinLoading">
        <a-form-model
            ref="form"
            :model="form"
            :rules="rules"
            class="custom pick-100 form-input"
        >
          <a-row v-if="!ifEdit">
            <process-selector @change="onChangeProcess"/>
          </a-row>
          <div class="hp-title">
            <div>&nbsp;</div>
            <span>基础信息</span>
          </div>
          <a-row>
            <a-col :span="7">
              <a-form-model-item label="申请处室" prop="applyDept">
                <dept-selector v-if="deptDisabled" :value="form.applyDept" style="width: 100%"
                               @change="v => form.applyDept = v"/>
                <a-input v-else v-model="deptName" disabled/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="申请人" prop="applyUser">
                <user-selector :value="form.applyUser" style="width: 100%" @change="v => form.applyUser = v"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="专家出行日期" prop="applyDate">
                <a-date-picker v-model="form.applyDate" :format="'yyyy-MM-DD'" style="width: 100%"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="7">
              <a-form-model-item label="项目名称" prop="projectName">
                <a-input v-model="form.projectName"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="计划使用天数" prop="planDays">
                <a-input-number v-model="form.planDays" :formatter="(value)=>{
                                              let reg = /^(-)*(\d+)\.(\d).*$/;
                                              return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg,'$1$2.$3');
                                            }" :max="365"
                                :min="0.5"
                                :parser="(value)=>{
                                              let reg = /^(-)*(\d+)\.(\d).*$/;
                                              return value.replace(/\s?|(,*)/g, '').replace(reg,'$1$2.$3');
                                            }"
                                :step="0.5" style="width:100%" @change="totalPrices"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="集合时间" prop="setOfTime">
                <a-date-picker v-model="form.setOfTime" :format="'yyyy-MM-DD HH:mm'"
                               :show-time="{ defaultValue: moment('09:00', 'HH:mm') }" style="width: 100%"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="7">
              <a-form-model-item label="项目内容" prop="projectContent">
                <a-textarea v-model="form.projectContent" rows="2"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="集合地点" prop="setOfAddr">
                <a-textarea v-model="form.setOfAddr" rows="2"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="出席需要携带的资料" prop="information">
                <a-textarea v-model="form.information" rows="2"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <div class="hp-title">
            <div>&nbsp;</div>
            <span>专家设置</span>
          </div>
          <a-row>
            <a-col :span="6">
              <a-form-model-item label="专业名称" prop="professionalName">
                <a-tree-select
                    v-model="selZYData"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :tree-data="zyTreeData"
                    allow-clear multiple
                    show-search
                    style="width: 100%"
                    treeNodeFilterProp="title"
                    @change="values => form.professionalName = values.join(',')"
                />
                <!--<dict-cascader dictKey="expert_profession" v-model="form.professionalName" style="width: 100%" />-->
              </a-form-model-item>
            </a-col>
            <a-col :span="4" offset="1">
              <a-form-model-item label="专家人数" prop="expertNumber">
                <a-input-number v-model="form.expertNumber" :max="20" :min="1" :precision="0" style="width:100%"
                                @change="totalPrices"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="4" offset="1">
              <a-form-model-item label="计划专家费用" prop="planExpertFees">
                <dict-cascader v-model="form.planExpertFees" dictKey="expertExpenditure_reward" style="width: 100%"
                               @change="totalPrices"/>
                <!--<a-input-number @change="totalPrices" :min="1" v-model="form.planExpertFees" style="width:100%"/>-->
              </a-form-model-item>
            </a-col>
            <a-col :span="4" offset="1">
              <a-form-model-item label="总价" prop="planTotalPrices">
                <a-input v-model="form.planTotalPrices" disabled readOnly/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6">
              <a-form-item label="年龄(选填)">
                <a-input-number @change="(val) => { ageSt = val }" v-model="ageSt"  :precision="0" :max="80" :min="20" style="width: 35%"/>
                &nbsp;到&nbsp;
                <a-input-number @change="(val) => { ageEt = val }" v-model="ageEt" :precision="0" :max="80" :min="20" style="width: 35%"/>
              </a-form-item>
            </a-col>
            <a-col :span="4" offset="1">
              <a-form-item label="性别(选填)">
                <dict-cascader v-model="form.gender"
                               dictKey="PEOPLE.SEX"
                               placeholder="性别"
                               @change="(val) => { form.gender = val }"
                />
              </a-form-item>
            </a-col>
            <a-col :span="4" offset="1">
              <a-form-item label="职称(选填)">
                <dict-cascader v-model="form.professionalTitle"
                               dictKey="expert_professionalTitle"
                               placeholder="职称"
                               style="width: 71%"
                               @change="(val) => { form.professionalTitle = val }"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>

      <a-modal :visible="setRuleVisible"
               :width="600"
               title="设置规则"
               @cancel="setRuleVisible = false,extractRules.extractInterval = extractInterval;"
               @ok="editExtractRules()">
        <table class="fx-form-view">
          <col width="150px"/>
          <col/>
          <tr>
            <th>专家抽取天数间隔</th>
            <td>
              <a-input-number v-model="extractRules.extractInterval" :min="0" style="width:100%"/>
            </td>
          </tr>
        </table>
      </a-modal>
      <div id="Link-Props" style="height: 50px"></div>

      <appoint-pact-modal ref="appointPactModal" :visible="modalVisible.pact" @cancel="modalVisible.pact = false"
                          @success="onPactSuccess"/>
      <external-pact-modal ref="externalPactModal" :visible="modalVisible.external"
                           @cancel="modalVisible.external = false"
                           @success="onExternalSuccess"/>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import qs from 'qs'
import moment from 'moment'
import UserSelector from '@/components/selector/UserSelector'
import DeptSelector from '@/components/selector/DeptSelector'
import ProcessSelector from '@/components/workflow/ProcessSelector'
import DictCascader from '@/components/dict/DictCascader'

import { verify } from '@/epp/expertmain/common/js/verify.js'
import AppointPactModal from '@/epp/expertmain/selectexpertapply/modal/AppointPactModal'
import ExternalPactModal from '@/epp/expertmain/selectexpertapply/modal/ExternalPactModal'

const uuidv4 = require('uuid/v4')
const rules = {
  applyUser: [{ required: true, message: '申请人不能为空！', trigger: 'change' }],
  applyDept: [{ required: true, message: '申请处室不能为空！', trigger: 'change' }],
  applyDate: [{ required: true, message: '专家出行日期不能为空！', trigger: 'change' }],
  planDays: [{ required: true, message: '计划使用天数不能为空！', trigger: 'change' }],
  professionalName: [{ required: true, message: '专业名称不能为空！', trigger: 'change' }],
  planExpertFees: [{ required: true, message: '计划专家费用不能为空！', trigger: 'change' }],
  expertNumber: [{ required: true, message: '专家人数不能为空！', trigger: 'change' }],
  setOfTime: [{ required: true, message: '集合时间不能为空！', trigger: 'change' }],
  setOfAddr: [{ required: true, message: '集合地点不能为空！', trigger: 'change' }],
  information: [{ required: false, message: '出席需要携带的资料不能为空！', trigger: 'change' }],
  expertName: [{
    min: 1,
    max: 10,
    pattern: verify.pattern_Chinese,
    message: '姓名有误！长度应在2~10个中文',
    trigger: 'blur'
  }],
  planTotalPrices: [{ required: true, message: '总价不能为空！', trigger: 'blur' }],
  selectExpert: [{
    required: false,
    message: '请在填写完“专业名称”和“专家人数”之后点击“随机生成”抽取专家并点击“确定”选定专家！',
    trigger: 'change'
  }],
  projectName: [{
    min: 1,
    max: 150,
    required: true,
    whitespace: true,
    message: '项目名称不能为空！最多150个字符',
    trigger: 'blur'
  }],
  projectContent: [{
    min: 1,
    max: 300,
    required: true,
    whitespace: true,
    message: '项目内容不能为空！最多300个字符',
    trigger: 'blur'
  }]
}
export default {
  name: 'SelectExpertApplyForm',
  components: {
    ExternalPactModal,
    AppointPactModal,
    PageView,
    DictCascader,
    UserSelector,
    DeptSelector,
    ProcessSelector
  },
  props: {
    id: String
  },
  data () {
    return {
      rules,
      applyState: '0',
      extractInterval: 0,
      user: this.$ls.get('user'),
      setRuleVisible: false,
      saveLoading: false,
      spinLoading: false,
      ifLotto: false,
      ifEdit: false,
      ifA: true,
      procId: '',
      expertName: '', // 指定专家名称
      zyTreeData: [],
      selZYData: null,
      cfmZJList: [],
      extractRules: { id: null, extractInterval: null },
      form: {
        id: uuidv4()
      },
      ageSt: '',
      ageEt: '',
      deptDisabled: false,
      deptName: '',
      modalVisible: {
        pact: false,
        external: false
      }
    }
  },
  created () {
    this.deptName = this.user.dept.name
    this.deptDisabled = this.user.permissions['expert.use.admin']
    if (this.id) {
      this.loadData()
      this.ifEdit = true
    } else {
      this.form = { ...this.initForm() }
    }
    this.loadExtractRules()
    this.loadZYTreeData()
  },
  watch: {
    id (val) {
      if (val) {
        this.loadData()
        this.ifEdit = true
      } else {
        this.form = { ...this.initForm() }
      }
    },
    form (val) {
      this.$emit('change', val)
    }
  },
  computed: {
    // planTotalPrices () {
    //   var totalPrices = 0
    //   if (this.form.planDays && this.form.expertNumber) {
    //     totalPrices = this.form.planDays * this.form.expertNumber * this.form.planExpertFees
    //   }
    //   this.form.planTotalPrices = totalPrices
    //   return totalPrices
    // }
  },
  methods: {
    moment,
    initForm () {
      return {
        id: uuidv4(),
        applyUser: this.user.id,
        applyDept: this.user.deptId,
        // applyDate: moment(),
        professionalName: null
      }
    },
    totalPrices () {
      if (!this.form.planDays) {
        return
      }
      var s = this.form.planDays.toString()
      var arr = s.split('.')
      // console.log(arr.length)
      if (arr.length > 1) {
        var s1 = arr[1] + '0'
        var s2 = s1.substring(0, 1)
        if (s2 > 5) {
          this.form.planDays = Number(arr[0]) + 1
        } else if (s2 < 5) {
          this.form.planDays = Number(arr[0]) + 0.5
        }
      }
      var totalPrices = 0
      if (this.form.planDays && this.form.expertNumber && this.form.planExpertFees) {
        totalPrices = this.form.planDays * this.form.expertNumber * this.form.planExpertFees
      }
      this.form.planTotalPrices = totalPrices
    },
    onChangeProcess (id) { // 选择流程
      this.procId = id
    },
    async loadData () {
      this.spinLoading = true
      const res = await this.$http.get(`/api/1/expertmain/selectExpertApply/get_selectExpertApply.json?id=${this.id}`)
      this.spinLoading = false
      if (res.code !== 200) {
        return
      }
      console.log(res.result)
      this.form = res.result
      this.form.applyDate = moment(this.form.applyDate)
      this.form.setOfTime = moment(this.form.setOfTime)
      this.selZYData = res.result.professionalName.split(',')
      this.cfmZJList = res.result.extras.expertList
      this.ageSt = res.result.extras.condition.ageSt
      this.ageEt = res.result.extras.condition.ageEt
      this.form.professionalTitle = res.result.extras.condition.professional
      this.form.gender = res.result.extras.condition.gender
      this.form.conId = res.result.extras.condition.id
    },
    // 获取专业类别
    loadZYTreeData () {
      const that = this
      this.$http.get(`/api/1/dict/cache/items.json?key=expert_profession`).then(res => {
        if (res.code !== 200) {
          return
        }
        that.zyTreeData = that.mapTreeData(res.result)
      })
    },
    mapTreeData (list, type) {
      const that = this
      if (!list) {
        return []
      }
      return list.map(item => {
        return {
          key: item.id,
          // value: item.id + '|' + item.name,
          value: item.value,
          title: item.name,
          children: that.mapTreeData(item.children, type)
        }
      })
    },
    // 获取选取专家抽取规则
    loadExtractRules () {
      const that = this
      this.$http.get(`/api/1/expertmain/selectExpertExtractRules/get_selectExpertExtractRules.json`).then(res => {
        if (res.code !== 200) {
          return
        }
        that.extractRules = res.result
        that.extractInterval = that.extractRules.extractInterval
      })
    },
    // 编辑选取专家抽取规则
    editExtractRules () {
      const that = this
      this.$http.post(`/api/1/expertmain/selectExpertExtractRules/update_selectExpertExtractRules.json`, qs.stringify(this.extractRules)).then(res => {
        if (res.code !== 200) {
          return
        }
        that.extractInterval = that.extractRules.extractInterval
        this.$message.success(`设置规则成功`)
        that.$refs.SETable.onRefresh()
        that.setRuleVisible = false
      })
    },
    expertChange (ids, names) {
      this.form.selectExpert = ids
      this.form.selectExpertName = names
    },
    onSave () {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        if (this.procId.length === 0 && !this.ifEdit) {
          this.$message.error('未选择启动流程，请选择启动流程！')
          return
        }
        // if (!this.form.selectExpert || this.form.selectExpert.length === 0) {
        //   this.$message.error('请在填写完“专业名称”和“专家人数”之后点击“随机生成”抽取专家并点击“确定”选定专家！')
        //   return
        // }
        // let selExpertNum = this.form.selectExpert.split(',')
        // if (this.form.expertNumber < selExpertNum.length) {
        //   this.$message.error('选取专家的数量，大于所设置的专家数量！')
        //   return
        // }
        const data = { ...this.form }
        console.log(data)

        data.procId = this.procId
        data.caseTypeId = this.$route.query.caseTypeId
        data.applyDate = data.applyDate.format('YYYY-MM-DD')
        data.setOfTime = data.setOfTime.format('YYYY-MM-DD hh:mm')
        data.applyState = this.applyState
        data.ageSt = this.ageSt
        data.ageEt = this.ageEt

        delete data.extras
        const api = this.id ? '/api/1/expertmain/selectExpertApply/update_Apply_auto.json' : '/api/1/expertmain/selectExpertApply/add_auto_selectExpertApply.json'
        let msgType = this.id ? '编辑' : '添加'
        this.saveLoading = true
        const res = await this.$http.post(api, data)
        this.saveLoading = false
        if (res.code !== 200) {
          this.$message.error(`${msgType}失败`)
        } else {
          this.$message.success(`${msgType}成功`)
          this.$router.push({
            path: '/selectExpertApply/view?id=' + data.id
          })
        }
      })
    },
    onAppoint () {
      this.modalVisible.pact = true
      this.$refs.appointPactModal.onStartLoadData()
    },
    onPactSuccess () {
      this.modalVisible.pact = false
      // 跳转 -- 新页面
      this.$router.push({ path: '/selectExpertApply/appoint/add?caseTypeId=' + this.$route.query.caseTypeId })
    },
    onExternalExpert () {
      this.modalVisible.external = true
      this.$refs.externalPactModal.onStartLoadData()
    },
    onExternalSuccess () {
      this.modalVisible.external = false
      // 跳转 -- 新页面
      this.$router.push({ path: '/selectExpertApply/external/add?caseTypeId=' + this.$route.query.caseTypeId })
    }
  }
}
</script>

<style scoped>
.hp-title {
  padding-top: 15px;
  padding-bottom: 15px;
}

.hp-title div {
  height: 18px;
  border-left: 5px solid dodgerblue;
  width: 15px;
  display: inline-block;
}

.hp-title span {
  font-size: 16px;
  font-weight: bold
}
</style>
